import { render } from "./searchArticle.vue?vue&type=template&id=2524a97e"
import script from "./searchArticle.vue?vue&type=script&lang=js"
export * from "./searchArticle.vue?vue&type=script&lang=js"

import "./searchArticle.vue?vue&type=style&index=0&id=2524a97e&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__